import React, { useMemo } from 'react';
import {
  AlertTitle,
  Alert,
  Button,
  Checkbox,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Toolbar,
  Typography,
  Box,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearchengin } from '@fortawesome/free-brands-svg-icons';
import { faCalculator, faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { EditorControls } from '../../BaseEditor';
import useIndexongContrctService from './hook';
import Loader from '../../../components/MaterialUI/loader';

const months = [...Array(12)].map((_, n) => {
  const d = new Date();
  d.setMonth(n);
  return {
    value: n,
    display_name: d.toLocaleDateString('uk', { month: 'long' }),
  };
});

function IndexingContractsEditor() {
  const {
    org, onSetOrg, currentUser, loading, onLoad, onSave,
    err, success, contracts, onToggleContract, onAll,
    mont, setMont, year, setYear,
  } = useIndexongContrctService();
  const checkedContracts = useMemo(
    () => contracts.filter((c) => c.checked).length,
    [contracts],
  );
  return (
    <Paper sx={{ p: 2 }}>
      {loading && (
      <Loader text="Завантаження" />
      )}
      <Typography variant="h6" color="primary">
        Розрахунок індексації орендної плати
      </Typography>
      {err && (
        <Alert severity="error">
          <AlertTitle>:-(</AlertTitle>
          {err}
        </Alert>
      )}
      {success && (
        <Alert severity="success">
          <AlertTitle>:-)</AlertTitle>
          Розрахунок виконано вдало!
        </Alert>
      )}
      { currentUser.is_superuser && (
      <EditorControls.ItemPicker
        value={org}
        onChange={(e, v) => onSetOrg(v)}
        backend="/api/catalogs/org/"
      />
      )}
      <Box display="flex" gap={2} sx={{ width: '50vw' }}>
        <EditorControls.Selector
          label="Місяць"
          value={mont}
          values={months}
          onChange={(e, v) => setMont(v)}
        />
        <EditorControls.NumerInput
          label="Рік"
          value={year}
          minValue={2022}
          maxValue={2032}
          onChange={(e, v) => setYear(v)}
        />
      </Box>
      <Toolbar sx={{ gap: 1 }}>
        <Button
          variant="contained"
          startIcon={<FontAwesomeIcon icon={faSearchengin} />}
          color="primary"
          disabled={loading}
          onClick={() => onLoad()}
        >
          Пошук договорів
        </Button>
        <Button
          variant="contained"
          startIcon={<FontAwesomeIcon icon={faCalculator} />}
          color="success"
          disabled={loading || !checkedContracts}
          onClick={() => onSave()}
        >
          Виконати розрахунок
        </Button>
        <Button
          variant="outlined"
          startIcon={<FontAwesomeIcon icon={faCheckDouble} />}
          color="info"
          onClick={() => onAll(true)}
        >
          Відмітити всі
        </Button>
        <Button
          variant="outlined"
          startIcon={<FontAwesomeIcon icon={faSquare} />}
          color="info"
          onClick={() => onAll(false)}
        >
          Зняти всі відмітки
        </Button>

      </Toolbar>
      <List>
        {contracts.map((contract) => (
          <ListItemButton dense onClick={() => onToggleContract(contract.id)}>
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={contract.checked}
                tabIndex={-1}
                disableRipple
              />
            </ListItemIcon>
            <ListItemText>
              {contract.repr}
            </ListItemText>
          </ListItemButton>
        ))}
      </List>
    </Paper>
  );
}

export default IndexingContractsEditor;
